import {default as axios} from "../api/axiosConfig";
import config from "../config";
import {ProductType} from "../api/model/common";

export interface Monitoring {
    msg: string;
    timestamp: Date;
    duration:number;
	username: string;
	operation: string;
	parameters: any[];
    appName:string;
    host: {
        ip:  any,
        name: any
    };
    functionalModule:string;
    logtype:string;
    severity:string;
}

export enum LogFunctionalModule {STORE_EMTPL = "STORE_EMTPL", STORE_TRAVEL = "STORE_TRAVEL", STORE_GREEN_CARD = "STORE_GREEN_CARD"}

export const getFuncMod = (type: ProductType) => {
    switch (type) {
        case ProductType.EMTPL:
            return LogFunctionalModule.STORE_EMTPL
        case ProductType.TRAVEL:
            return LogFunctionalModule.STORE_TRAVEL
        case ProductType.GREEN_CARD:
            return LogFunctionalModule.STORE_GREEN_CARD
    }
}

export async function sendLog(date:Date, functionalModule: LogFunctionalModule, severity: "ERROR" | 'INFO', operation:string, parameters:any[], message:string = '') {
    try {
        const monitoring = {} as Monitoring;
        monitoring.appName = "webshop-fe";
        monitoring.timestamp = date;
        monitoring.severity = severity; //"ERROR"; // 'INFO'
        monitoring.operation = operation; // тип операции капсом сампридумай
        monitoring.username = "unknown";
        monitoring.parameters = parameters; // quotation id и другие полезные штуки
        monitoring.msg = message;
        const publicIp = require('public-ip');
        monitoring.host = {"ip" :  await publicIp.v4(), "name": window.location.hostname};
        monitoring.logtype = "MONITORING";
        monitoring.functionalModule = functionalModule;
        monitoring.duration = new Date().getTime() - monitoring.timestamp.getTime();
        await axios.post(`${config.LOG_SERVER}`, monitoring);
    } catch (error) {
        console.log(error)
    }
   
}